import {UiTheme, UiThemeSize} from "@view/theme/types";
import {LARGE_THEME_SIZE_COMPONENTS} from "@view/theme/styles/largeTheme";
import {SMALL_THEME_SIZE_COMPONENTS, SMALL_THEME_SIZE_TYPOGRAPHY} from "@view/theme/styles/smaillTheme";

export const buildThemeStyles = ({
                                     theme,
                                     forcedTheme,
                                     themeSize,
                                     forcedThemeSize,
                                 }: {
    theme: UiTheme,
    forcedTheme?: UiTheme,
    themeSize: UiThemeSize,
    forcedThemeSize?: UiThemeSize,
}) => {

    const mode = forcedTheme ?? theme
    const currentThemeSize = forcedThemeSize ?? themeSize
    switch (currentThemeSize) {
        case "large": {
            return {
                palette: {
                    mode,
                },
                components: LARGE_THEME_SIZE_COMPONENTS
            }
        }
        case 'small': {
            return {
                palette: {
                    mode,
                },
                typography: SMALL_THEME_SIZE_TYPOGRAPHY,
                components: SMALL_THEME_SIZE_COMPONENTS
            }
        }
    }
}